import React, { useState, useEffect } from "react";

export default function DraggableTagList({ itemList, removeAction, saveOrder, renderTagContent }) {
    const [tags, setTags] = useState([]);

    useEffect(() => {
        console.log(itemList)
        if (itemList) {
            setTags(itemList);
            saveOrder(itemList);
        }
    }, [itemList]);

    const handleDragStart = (e, index) => {
        e.dataTransfer.setData("dragIndex", index);
    };

    const handleDragOver = (e) => {
        e.preventDefault();
    };

    const handleDrop = (e, dropIndex) => {
        const dragIndex = e.dataTransfer.getData("dragIndex");
        const updatedTags = [...tags];
        const [draggedTag] = updatedTags.splice(dragIndex, 1);
        updatedTags.splice(dropIndex, 0, draggedTag);
        setTags(updatedTags);
        saveOrder(updatedTags);
    };

    return (
        <>
            {tags && tags.length > 0 && (
                <div className="field">
                    <div className="control">
                        <div
                            className="tags"
                            style={{
                                display: "flex",
                                flexWrap: "nowrap",
                                overflowX: "auto",
                                cursor: "grab",
                            }}
                        >
                            {tags.map((item, index) => (
                                <span
                                    key={index}
                                    className="tag is-warning"
                                    draggable
                                    onDragStart={(e) => handleDragStart(e, index)}
                                    onDragOver={handleDragOver}
                                    onDrop={(e) => handleDrop(e, index)}
                                    style={{ cursor: "grab", marginRight: "0.5rem" }}
                                >
                                    {renderTagContent ? renderTagContent(item) : item.name}
                                    <button
                                        className="delete is-small"
                                        onClick={() => removeAction(index)}
                                    ></button>
                                </span>
                            ))}
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}